import badge20 from 'assets/images/20_badge.png';
import badge25 from 'assets/images/25_badge.png';
import badge50 from 'assets/images/50_badge.png';

const badgeBronze = 'https://front.travpromobile.com/1441/USA_badge_bronze.png';
const badgeGolden = 'https://front.travpromobile.com/1441/USA_badge_gold.png';
const badgePlatinum = 'https://front.travpromobile.com/1441/USA_badge_platinum.png';
const badgeSilver = 'https://front.travpromobile.com/1441/USA_badge_silver.png';

const exports = {
  badge20,
  badge25,
  badge50,
  tierBadges: [badgeBronze, badgeSilver, badgeGolden, badgePlatinum],
};

export default exports;
